import Api from '#services/api'
import actions from 'redux-auto'
import i18n from 'i18next'

export function pending(user) {
  return {
    ...user,
  }
}

export function fulfilled(user) {
  return {
    ...user,
    acceptedPrivacyPolicy: true,
  }
}

export function rejected(user) {
  return {
    ...user,
  }
}

export async function action() {
  try {
    await Api.acceptPrivacyPolicy()
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
